import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M39.908 18.075A20 20 0 1 1 .11 22.103a1.875 1.875 0 0 1 3.73-.396 16.25 16.25 0 1 0 24.91-15.4v4.318a1.875 1.875 0 1 1-3.75 0V0h10.625a1.875 1.875 0 1 1 0 3.75H31.66a20 20 0 0 1 8.247 14.325M17.5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-5.625.625a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M3.75 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h40v40H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }